import { SxProps } from '@mui/material';

export const TableSx = (isProcurementToRecipient: boolean): SxProps => ({
  marginTop: '0.5rem',
  maxWidth: isProcurementToRecipient ? '100%' : '700px',
  borderTop: '1px solid #E0E0E0',
});
